import { capitalGlobalQuotesService } from '@/services/quotes/capital-global';
import type { BusinessUnderwritingMessagesResponse } from '@/services/quotes/types';
import { useQuery } from '@tanstack/react-query';

export function useCapitalGlobalUnderwritingMessages(
  policyId: string | undefined,
  enabled = true,
) {
  return useQuery<BusinessUnderwritingMessagesResponse>({
    queryKey: ['capital-global', 'underwriting-messages', policyId],
    queryFn: async () => {
      if (!policyId) {
        throw new Error('policyId é obrigatório');
      }
      const response =
        await capitalGlobalQuotesService.getUnderwritingMessages(policyId);
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar mensagens de subscrição',
        );
      }
      return response.data;
    },
    enabled: enabled && Boolean(policyId),
    retry: false,
  });
}
